export default "__VITE_ASSET__G3R6VzB6__"